import img_1 from './assets/img_1.png';
import img_2 from './assets/img_2.png';
import img_3 from './assets/img_3.png';
import img_4 from './assets/img_4.png';
import img_5 from './assets/img_5.png';
import img_6 from './assets/img_6.png';
import img_7 from './assets/img_7.png';
import img_8 from './assets/img_8.png';
import img_9 from './assets/img_9.png';
import img_10 from './assets/img_10.png';
import img_11 from './assets/img_11.png';
import img_12 from './assets/img_12.png';
import img_13 from './assets/img_13.png';

export const reviews = [
  {
    id: '1',
    name: 'Attention',
    link: '@TheAttentionETH',
    text: [
      'Themis is just something out of this world! Absolutely love it! Highly recommend every community!',
    ],
    avatar: img_1,
  },
  {
    id: '2',
    name: 'BodyaDodya',
    link: '@BodyaDodya',
    text: [
      'They clearly know their stuff! Probably one of the best bots for discord - just a godsend. Constant support and help in setting up (for which special thanks). Guys show quite a high level, despite the fact that the bot just appeared on the market. Thank you for the product! Koi-real GOAT',
    ],
    avatar: img_2,
  },
  {
    id: '3',
    name: 'Aru',
    link: '@0xAruu',
    text: [
      'The founder dev is very approachable and knows what he is building. The free version is enough for basic discord servers but paying for the paid version is worth every bucks and it is inexpensive for the peace of mind and service they can give.',
    ],
    avatar: img_3,
  },

  {
    id: '4',
    name: 'akinawa',
    link: '@aki-aki',
    text: [
      'Themis is a game-changer for anyone looking to keep their Discord server secure. Design is seamless, and Themis is highly customizable. I recently tested the fake detection feature, and it`s truly amazing!',
    ],
    avatar: img_4,
  },

  {
    id: '5',
    name: 'AceKawaii💫',
    link: '@kawaiiiiii',
    text: [
      'I recently used this bot on Discord and I have to say, I`m thoroughly impressed! The features are top-notch and it has greatly improved my Discord experience. The setup process was simple and straightforward, and the bo`s response time is lightning fast. The commands are easy to use and provide valuable information. Overall, I highly recommend Themis Discord bot to anyone looking for a quality Discord experience.',
    ],
    avatar: img_5,
  },

  {
    id: '6',
    name: 'DAT BOI 🫡',
    link: '@datdegenboi',
    text: ['yo, love Themis!', 'def want users to solve captcha before joining though'],
    avatar: img_6,
    check: true,
  },
  {
    id: '7',
    name: 'Genesis',
    link: '@genesis_forever',
    text: [
      'Incredible bot for security. Super kind and approachable founder. This bot will definitely be up there some day, and I`m proud to be one of the first ones to use it!',
    ],
    avatar: img_7,
  },
  {
    id: '8',
    name: 'Delec',
    link: '@Delec_eth',
    text: [
      'I am incredibly happy with the experience of using this bot. I didn’t even think that someone really cares about the simple interface for server owners who are not particularly versed in high-quality settings. I was lucky to get into personal contact with the developer and resolve all issues personally, although the documentation is very clear, but it will not be superfluous. Before that, I tried to make a server with other similar solutions on the bot market, but guys, without further ado, ',
    ],
    avatar: img_8,
  },
  {
    id: '9',
    name: 'Goose',
    link: '@GooseXBT',
    text: [
      'I manage multiple Discord servers and I have to say, this is the top security bot - best one out there. No other bot is smoother or as effective as this one.',
    ],
    avatar: img_9,
    check: true,
  },
  {
    id: '10',
    name: 'Luke Belmar 👽',
    link: '@lukebelmar',
    text: [
      'If someone has to tell you to forget about your server security or trust the default security then you will fail it.',
      'So, keep calm and use Themis!',
    ],
    avatar: img_10,
    check: true,
  },
  {
    id: '11',
    name: 'Sourcerer',
    link: '@the_sourcerer',
    text: [
      'Good bot! Love to use it for every server I manage.',
      'Free features are amazing! But premium ones are even more better!!! Gonna upgrade soon!',
    ],
    avatar: img_11,
  },
  {
    id: '12',
    name: 'Cam BAKUZA 🥚',
    link: '@cameael',
    text: [
      'Firstly, we have some exciting updates to share with you all! As we mentioned before, our vision for Bakuza is to create a decentralized ecosystem. But the talented team needs a backup, which is why we chose Themis. This is the most powerful tool on the market that not only helps to protect what we love, but also show how we can improve things.',
    ],
    avatar: img_12,
  },

  {
    id: '13',
    name: 'Samie',
    link: '@ExtRaNgHeRo',
    text: [
      'For server moderation and maintenance, we have been utilizing Themis (also known as bot slayer) for more than a year. It is a highly effective and adaptable Discord bot. Strong moderating options like configurable messages, auto-moderation, and anti-spam defense are provided by the bot. Themis is a vital bot for any Discord server seeking effective moderation and management overall, plus approachable dev!',
    ],
    avatar: img_13,
  },
];
